import type { FaceExamineStatus } from '@/api/activity/type'
import type { CompareState } from '@/api/evaInfo/type'

export const getCompareStateFromExamineStatus = (
  faceExamineStatus: FaceExamineStatus
): CompareState => {
  // 活动侧的人脸人工审核状态优先级更高，需要覆盖本地缓存状态。
  if (faceExamineStatus === 'unexam') {
    return 'underReview'
  }

  if (faceExamineStatus === 'passFace') {
    return 'success'
  }

  return 'failNotPass'
}

export const normalizeCompareRecordState = ({
  currentState,
  faceUseNumber,
  faceNumber,
  isFacePass
}: {
  currentState?: CompareState
  faceUseNumber: number
  faceNumber: number
  isFacePass: boolean
}): CompareState | undefined => {
  // 当识别次数耗尽时，把中间失败态折叠成最终失败态。
  if (!currentState || !['failNotPass', 'failPass', 'fail'].includes(currentState)) {
    return currentState
  }

  if (faceUseNumber >= faceNumber) {
    return isFacePass ? 'failPass' : 'failNotPass'
  }

  return 'fail'
}

export const resolveActivityCompareState = ({
  recordState,
  isFaceExamine,
  faceExamineStatus
}: {
  recordState?: CompareState
  isFaceExamine: boolean
  faceExamineStatus: FaceExamineStatus | null
}): CompareState | undefined => {
  if (isFaceExamine && faceExamineStatus) {
    return getCompareStateFromExamineStatus(faceExamineStatus)
  }

  return recordState
}

export const resolveCompareState = ({
  remainingCompareCount,
  isFacePass,
  isPass,
  hasCompared
}: {
  remainingCompareCount: number
  isFacePass: boolean
  isPass: boolean
  hasCompared: boolean
}): CompareState => {
  // 统一的人脸识别状态计算，供 evaInfo 页面和 activity 入口共用。
  if (remainingCompareCount === 0 && isFacePass && !isPass) {
    return 'failPass'
  }

  if (remainingCompareCount === 0 && !isFacePass && !isPass) {
    return 'failNotPass'
  }

  if (hasCompared && !isPass) {
    return 'fail'
  }

  if (isPass && hasCompared) {
    return 'success'
  }

  return 'tips'
}
